---
title: Thiết lập Email & hộp thư
parent: Tài liệu
parentHref: /docs
---

# Thiết lập hộp thư email của bạn

Gói TOBY của bạn bao gồm một địa chỉ email chuyên nghiệp khớp với tên miền của bạn (ví dụ: info@ten-mien-cua-ban.de) với **hộp thư 15 GB (Maxi-Postfach)**, cùng với số lượng địa chỉ chuyển tiếp email không giới hạn. Bạn cần thêm hộp thư hoặc dung lượng lưu trữ? Bạn có thể thêm hộp thư 15 GB khác bất cứ lúc nào — xem [bảng giá](/vi/pricing).

## 1. Tạo hộp thư của bạn trong TOBY

1. Mở **Cài đặt → Email** trong TOBY.
2. Chọn địa chỉ bạn muốn (như info@, hello@, hoặc contact@) và tạo hộp thư.
3. **Sao chép mật khẩu của bạn:** TOBY hiển thị mật khẩu hộp thư được tạo một lần ngay sau khi tạo. Hãy sao chép hoặc lưu lại trước khi đóng cửa sổ. (Nếu bạn quên mật khẩu, bạn có thể tạo mật khẩu mới chỉ với một cú nhấp chuột trong **Cài đặt → Email** — các email hiện có của bạn vẫn an toàn.)

## 2. Đọc và gửi email trên trình duyệt (Webmail)

Bạn có thể mở hộp thư đến từ bất kỳ trình duyệt máy tính hoặc điện thoại nào mà không cần cài đặt ứng dụng:

- **Địa chỉ Webmail:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Tên đăng nhập:** địa chỉ email đầy đủ của bạn (ví dụ: info@ten-mien-cua-ban.de)
- **Mật khẩu:** mật khẩu hộp thư từ **Cài đặt → Email**

## 3. Kết nối điện thoại hoặc máy tính của bạn (IMAP & SMTP)

Để đọc và gửi email trong **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook**, hoặc **Thunderbird**, hãy thêm tài khoản **IMAP** mới trong ứng dụng email của bạn và nhập các cài đặt máy chủ sau:

| Cài đặt | Giá trị |
| --- | --- |
| **Loại tài khoản** | IMAP |
| **Địa chỉ email / Tên đăng nhập** | Địa chỉ email đầy đủ của bạn (ví dụ: info@ten-mien-cua-ban.de) |
| **Mật khẩu** | Mật khẩu hộp thư của bạn từ Cài đặt → Email |
| **Máy chủ thư đến (IMAP)** | mail.tobysite.com |
| **Cổng thư đến** | 993 (SSL/TLS) |
| **Máy chủ thư đi (SMTP)** | mail.tobysite.com |
| **Cổng thư đi** | 465 (SSL/TLS) hoặc 587 (STARTTLS) |

> **Quan trọng:** Đảm bảo bạn nhập **địa chỉ email đầy đủ** (bao gồm @ten-mien-cua-ban.de) làm tên đăng nhập cho **cả** máy chủ thư đến (IMAP) và thư đi (SMTP).

### Hướng dẫn từng bước trên iPhone & iPad (iOS Mail)

1. Mở ứng dụng **Cài đặt** trên iPhone → **Ứng dụng** → **Mail** → **Tài khoản Mail** → **Thêm Tài khoản** → **Khác** → **Thêm Tài khoản Mail**.
2. Nhập tên của bạn, địa chỉ email đầy đủ, mật khẩu hộp thư và mô tả ngắn. Nhấn **Tiếp theo**.
3. Giữ **IMAP** được chọn ở trên cùng.
4. Trong **Máy chủ Thư Đến** và **Máy chủ Thư Đi**, nhập mail.tobysite.com làm Tên Máy chủ, địa chỉ email đầy đủ của bạn làm Tên Người dùng, và mật khẩu hộp thư của bạn.
5. Nhấn **Tiếp theo** rồi **Lưu**.

### Hướng dẫn từng bước trên Android (ứng dụng Gmail)

1. Mở ứng dụng **Gmail**, nhấn vào ảnh hồ sơ ở góc trên bên phải → **Thêm tài khoản khác** → **Khác**.
2. Nhập địa chỉ email đầy đủ của bạn và nhấn **Thiết lập thủ công** → **Cá nhân (IMAP)**, sau đó nhập mật khẩu của bạn.
3. Đối với **Máy chủ đến**, đặt máy chủ là mail.tobysite.com, cổng 993, và loại bảo mật SSL/TLS.
4. Đối với **Máy chủ SMTP đi**, đặt máy chủ là mail.tobysite.com, cổng 465 (SSL/TLS), và đảm bảo **Yêu cầu đăng nhập** được bật với địa chỉ email đầy đủ của bạn.
5. Nhấn **Tiếp theo** để hoàn tất.

Tiếp theo: [Bản tin & thông báo](/vi/docs/newsletter).
